import { render, staticRenderFns } from "./swTopCompanies.vue?vue&type=template&id=af278934&scoped=true"
import script from "./swTopCompanies.vue?vue&type=script&lang=js"
export * from "./swTopCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af278934",
  null
  
)

export default component.exports